
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portal/action-items",
      function () {
        return require("private-next-pages/portal/action-items.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portal/action-items"])
      });
    }
  